import {
  greyColor, maxMobile, primaryColor, primaryFont, primaryHeadingColor, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  @media all and (max-width: ${maxMobile}) {
    margin-bottom: 10px;
  }
  .badge-side {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    border: 1px solid #E1E1E1;
    @media all and (max-width: ${maxMobile}) {
      width: 40px;
      height: 40px;
    }
    .logo-img {
     height: 100%;
     width: 100%;
     border-radius: 8px;
    }
  }
  .title-side {
    margin-left: 10px;
    &.titleSideMargin {
      margin-left: 20px;
      position: relative;
      &::before {
        content: '';
        height: 4px;
        width: 4px;
        position: absolute;
        left: -14px;
        top: 5px;
        background-color: rgb(66, 75, 80);
        border-radius: 50%;
      }
    }
    .title-section {
      color: ${primaryHeadingColor};
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 17px;
      letter-spacing: -0.375px;
      margin-bottom: 3px;
      @media all and (max-width: ${maxMobile}) {
        font-size: 12px;
        line-height: 14px;
        margin-bottom: 0px;
      }
    }
    .date-stamp{
      color: ${greyColor};
      font-family: ${primaryFont};
      font-size: 14px;
      font-style: normal;
      font-weight: ${wMedium};
      line-height: 16px;
      margin-bottom: 3px;
      display: block;
      @media all and (max-width: ${maxMobile}) {
        font-size: 10px;
        line-height: 14px;
        margin-bottom: 0px;
      }
    }
    .degree {
      color: ${primaryColor};
      font-family: ${primaryFont};
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
      margin: 3px 0px;
      @media all and (max-width: ${maxMobile}) {
        font-size: 10px;
        line-height: 14px;
      }
      &.colorChange {
        color: ${greyColor};
      }
    }
  }
  
`;

type Props = {
  logo?: string,
  title: string,
  date?: string,
  degree?: string,
  achDesc?: string,
  noImage?: boolean,
} & typeof defaultProps;

const defaultProps = {
  achDesc: '',
  noImage: false,
  logo: '',
  date: '',
  degree: '',
};

const EducationBadge = function EducationBadge(props: Props) {
  const {
    logo, title, date, degree, achDesc, noImage,
  } = props;
  return (
    <>
      <Wrapper className="career-widget">
        {noImage ? null : (
          <div className="badge-side">
            <img src={logo} alt="logo" className="logo-img" />
          </div>
        )}
        <div className={classNames('title-side', { titleSideMargin: noImage })}>
          {
            title
            && <h6 className="title-section">{title}</h6>
          }
          {
            degree
            && <span className={classNames('degree', { colorChange: noImage })}>{degree}</span>
          }
          {
            date
            && <span className="date-stamp">{date}</span>
          }
          {
            achDesc || noImage ? <span className="date-stamp">{achDesc}</span> : null
          }
        </div>
      </Wrapper>
      <span className="end-line" />
    </>
  );
};

EducationBadge.defaultProps = defaultProps;
export default EducationBadge;
